import { NgModule } from '@angular/core';
import { CommonModule, NgForOf } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FrontendDropdownComponent, FrontendDropdownPlainComponent } from './components';
import { FrontendTripleDotsModule } from '@tablesready/frontend-triple-dots';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendTooltipModule } from '@tablesready/frontend-tooltip';

const components = [FrontendDropdownComponent, FrontendDropdownPlainComponent];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    IonicModule,
    NgForOf,
    FrontendTripleDotsModule,
    FrontendIconsModule,
    FrontendTooltipModule,
  ],
  exports: [...components],
})
export class FrontendDropdownModule { }
